import { put } from "redux-saga/effects";
import { AuthService, ConfirmUserRequestResponse } from "../../../services/auth";
import { InitUserActivationRequestActionType } from "../types";
import { initUserActivationFailure, initUserActivationSuccess } from "../actionCreators";
import { IErrorType } from "../../types/errors.d";

export function* activateUserSaga({ payload: { code } }: InitUserActivationRequestActionType) {
    try {
        const { data }: ConfirmUserRequestResponse = yield AuthService.confirmUser(code);
        yield put(initUserActivationSuccess(data));
    } catch (error: any) {
        if (error.isAxiosError) {
            yield put(
                initUserActivationFailure({
                    errorType: IErrorType.AXIOS,
                    data: error.response ? error.response.dat : null,
                }),
            );
        } else {
            yield put(initUserActivationFailure({ errorType: IErrorType.NATIVE, data: error }));
        }
        return null;
    }
}
